import React, { useMemo } from 'react';
import { GroupedCheckboxDropdown } from 'components/common';
import PropTypes from 'prop-types';
const REGION_LABEL = {
  vn:       'Vietnam',
  vietnam:  'Vietnam',
  export:   'Export',
  exports:  'Export',
  th:       'Thailand',
  thailand: 'Thailand',
  ho:       'Head Office',
  hq:       'Head Office',
};

const REGION_COLOR = {
  Vietnam:     '#16a34a',
  Export:      '#0891b2',
  Thailand:    '#d97706',
  'Head Office': '#6366f1',
  Other:       '#6b7280',
};

const REGION_ORDER = ['Vietnam', 'Export', 'Thailand', 'Head Office', 'Other'];

const normalizeRegion = (r) => {
  if (!r) return 'Other';
  const key = r.toLowerCase().replace(/[\s_-]+/g, '');
  return REGION_LABEL[key] || (r.charAt(0).toUpperCase() + r.slice(1));
};

const buildGroups = (units) => {
  const groupMap = {};
  units.forEach((u) => {
    const region = normalizeRegion(u.region);
    if (!groupMap[region]) {
      groupMap[region] = {
        key:   region,
        label: region,
        color: REGION_COLOR[region] || REGION_COLOR.Other,
        items: [],
      };
    }
    groupMap[region].items.push({
      value: u.id,
      label: u.description || u.name || String(u.id),
    });
  });

  const ordered = REGION_ORDER
    .filter((r) => groupMap[r])
    .map((r) => groupMap[r]);

  Object.keys(groupMap).forEach((r) => {
    if (!REGION_ORDER.includes(r)) ordered.push(groupMap[r]);
  });

  return ordered;
};

const SalesUnitGroupedDropdown = ({ units, selectedIds, onChange, placeholder, width }) => {
  const groups = useMemo(() => buildGroups(units), [units]);

  return (
    <GroupedCheckboxDropdown
      groups={groups}
      selectedIds={selectedIds}
      onChange={onChange}
      placeholder={placeholder}
      width={width}
    />
  );
};

SalesUnitGroupedDropdown.propTypes = {
  units:       PropTypes.arrayOf(PropTypes.shape({
    id:          PropTypes.any.isRequired,
    name:        PropTypes.string,
    description: PropTypes.string,
    region:      PropTypes.string,
  })).isRequired,
  selectedIds: PropTypes.array.isRequired,
  onChange:    PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  width:       PropTypes.number,
};

SalesUnitGroupedDropdown.defaultProps = {
  placeholder: 'All units',
  width:       280,
};

export default SalesUnitGroupedDropdown;
